import { createAction } from "@reduxjs/toolkit";
import { UserActionTypes } from "./userTypes";
import { RegisterPayload } from "services/api.services/user/userService";

export const loginRequest = createAction<{ email: string; password: string }>(
  UserActionTypes.LOGIN_REQUEST,
);

export const loginSuccess = createAction<Record<string, any>>(
  UserActionTypes.LOGIN_SUCCESS,
);

export const loginFailure = createAction<string>(UserActionTypes.LOGIN_FAILURE);

export const logout = createAction(UserActionTypes.LOGOUT);

export const fetchSessionRequest = createAction(
  UserActionTypes.FETCH_SESSION_REQUEST,
);

export const fetchSessionSuccess = createAction<Record<string, any>>(
  UserActionTypes.FETCH_SESSION_SUCCESS,
);

export const fetchSessionFailure = createAction<string>(
  UserActionTypes.FETCH_SESSION_FAILURE,
);


// 🔹 Register actions
export const registerRequest = createAction<RegisterPayload>(
  UserActionTypes.REGISTER_REQUEST,
);

export const registerSuccess = createAction<Record<string, any>>(
  UserActionTypes.REGISTER_SUCCESS,
);

export const registerFailure = createAction<string>(
  UserActionTypes.REGISTER_FAILURE,
);
